import {openDB} from 'idb';

const $ = jQuery;
class QueryCache {
	constructor(indexName) {
		this.db = null;
		this.dbName = 'algolia-cache';
		this.storeName = 'hits'
		this.indexName = indexName;
		// short expiration for testing
		this.expiration = 1000 * 60 * 60;
		this.dbReady = new Promise( async (resolve, reject) => {
			const db = await openDB( this.dbName, 3, {
				upgrade: (db) => {
					const store = db.createObjectStore(this.storeName, {keyPath:'key'})
					store.createIndex('created', 'created', {unique: false});
				}
			});
			resolve(db);
		});
	}

	cleanup() {

	}

	clear(){
		if( this.db ){
			this.db.clear(this.storeName);
		}
	}

	async set(key, value) {
		let db = await this.dbReady;
		try {
			// db.set(this.storeName, {
			// 	key: `${this.indexName}:${key}`,
			// 	created: new Date(),
			// 	value
			// });
		}catch(e){
			
		}
	}

	async get(key) {
		if( 1 ){
			return null;
		}
		let db = await this.dbReady;
		let cacheKey = `${this.indexName}:${key}`;
		let result = db.get(this.storeName, cacheKey);
		// check for expiration
		if( (new Date()) - result.created > this.expiration ) {
			// delete this entry
			try {
				await db.delete(this.storeName, cacheKey);
			}
			catch(e){
				console.log('error deleting');
			}
		}
		return result.value;
	}
}
class Query {
	constructor(config) {
		this.results = {};
		this.lastResponse = null;
		this.lastRequest = null;

		this.request = {
			params: {
				highlightPreTag: '<em class="search-highlight">',
				highlightPostTag: '</em>',
				attributesToSnippet: [
					'content:30'
				],
				getRankingInfo: true,
				clickAnalytics: true
			}
		};

		$.extend(true, this, config || {});

		this.cache = new QueryCache( this.request.indexName );

	}

	getAlgoliaRequest(term, searchParameters = {}) {
		let req = $.extend(true, {}, this.request, {
			query: term
		});
		req = $.extend(true, req, searchParameters);
		return req;
	}

	hasResults() {
		return this.results && this.results.hits;
	}

	resultsError(err) {
		this.results = [];
	}

	clearCache() {
		this.cache.clear();
	}

	async search(term, searchParameters = {}) {
		term = term.toLowerCase().trim();
		const cacheKey = term + JSON.stringify(searchParameters);
		this.lastRequest = this.getAlgoliaRequest(term, searchParameters);
		// try to get the cache
		let results = null;
		if( this.target ){
			this.target.isSearching = true;
		}
		try {
			results = await this.cache.get(cacheKey);
		}catch(e){
			console.log(e);
			results = false;
		}
		if( !results ){
			results = await this.client.query(this.lastRequest);
			try {
				this.cache.set(cacheKey, results);
			}
			catch(e){
				console.log('error adding to cache');
			}
		}
		this.lastResponse = results;
		if (this.target) {
			this.target.queryID = results.queryID;
			this.target.hits = results.hits;
			this.target.response = results;
			this.target.isSearching = false;
		}
		return results;
	}

	hasMore() {
		if (this.lastResponse && this.lastResponse.page < this.lastResponse.nbPages - 1) {
			return true;
		}
		return false;
	}

	async loadMore() {
		if (!this.lastResponse) {
			return;
		}
		const req = $.extend(true, {
			...this.lastRequest
		}, {
			params: {
				page: 1 + (this.lastRequest.params.page || 0 )
			}
		});
		const cacheKey = JSON.stringify(req);
		this.lastRequest = req;

		let results = null;
		try {
			results = await this.cache.get(cacheKey);
		}catch(e){
			results = false;
		}
		if( !results ){
			results = await this.client.query(this.lastRequest);
			this.cache.set(cacheKey, results);
		}
		this.lastResponse = results;
		if (this.target) {
			this.target.queryID = results.queryID;
			this.target.hits = this.target.hits.concat(results.hits);
			this.target.response = results;
		}

		return results;


		// return new Promise((resolve, reject) => {
		// 	if (this.cache[cacheKey]) {
		// 		this.results = this.cache[cacheKey];
		// 		if (this.target) {
		// 			this.target.queryID = this.cache[cacheKey].queryID;
		// 			this.target.hits = this.target.hits.concat(this.cache[cacheKey].hits);
		// 			this.target.response = this.cache[cacheKey];
		// 		}
		// 		this.lastResponse = this.cache[cacheKey];
		// 		return resolve(this.cache[cacheKey].hits);
		// 	}
		// 	this.client.query(this.lastRequest).then(results => {
		// 		if (!results || !results.hits || !results.hits.length) {
		// 			return false;
		// 		}
		// 		console.log( results );
		// 		this.cache[cacheKey] = results;
		// 		if (this.target) {
		// 			this.target.queryID = this.cache[cacheKey].queryID;
		// 			this.target.hits = this.target.hits.concat(this.cache[cacheKey].hits);
		// 			this.target.response = this.cache[cacheKey];
		// 		}
		// 		this.lastResponse = this.cache[cacheKey];
		// 		return resolve(this.cache[cacheKey]);
		// 	});
		// });
	}
}

const queries = {
	all: (config) => {
		return new Query($.extend(true, {}, {
			label: 'Recommend Results',
			request: {
				indexName: 'asa_searchable_posts',
				params: {
					hitsPerPage: 4
				}
			}
		}, config || {}));
	},
	pagesAndArticles: (config) => {
		return new Query($.extend(true, {}, {
			label: 'Pages &amp; Articles',
			request: {
				indexName: 'asa_searchable_posts',
				params: {
					facetFilters: [
						'is_event:false',
						[
							"post_type_label:Posts",
							"post_type_label:Pages"
						]
					],
					hitsPerPage: 4
				}
			}
		}, config || {}));
	},
	events: (config) => {
		return new Query($.extend(true, {}, {
			label: 'Events',
			request: {
				indexName: 'asa_searchable_posts',
				params: {
					facetFilters: [
						"is_event:true"
					],
					hitsPerPage: 3
				}
			}
		}, config || {}));
	},
	publications: (config) => {
		return new Query($.extend(true, {}, {

			label: 'Publications',
			request: {
				indexName: 'asa_searchable_posts',
				params: {
					facetFilters: [
						"post_type_label:Issues"
					],
					hitsPerPage: 3
				}
			}
		}, config || {}));
	},
	suppliers: (config) => {
		return new Query($.extend(true, {}, {
			label: 'Industry Suppliers',
			request: {
				indexName: 'suppliers_searchable_posts',
				params: {
					hitsPerPage: 3
				}
			}
		}, config || {}));
	},
	marketplace: (config) => {
		return new Query($.extend(true, {}, {
			label: 'ASA Marketplace',
			request: {
				indexName: 'marketplace_searchable_posts',
				params: {
					hitsPerPage: 3
				}
			}
		}, config || {}));
	},
	staffingToday: (config) => {
		return new Query($.extend(true, {}, {
			label: 'Staffing Today',
			request: {
				indexName: 'st_searchable_posts',
				params: {
					hitsPerPage: 3
				}
			}
		}, config || {}));
	},
	techCompanies: (config) => {
		return new Query($.extend(true, {}, {
			label: 'Tech Companies',
			request: {
				indexName: 'asa_searchable_posts',
				params: {
					facetFilters: [
						'is_event:false',
						[
							"post_type_label:Tech Companies"
						]
					],
					hitsPerPage: 4
				}
			}
		}, config || {}));
	},
	sw: (config) => {
		return new Query($.extend(true, {}, {
			label: 'Staffing World',
			request: {
				indexName: 'sw23_searchable_posts',
				params: {
					hitsPerPage: 4
				}
			}
		}, config || {}));
	},
	allSites: (config) => {
		return new Query($.extend(true, {}, {
			label: 'All Sites',
			request: {
				indexName: 'wpms_multisite_posts',
				params: {
					hitsPerPage: 10,
					facets: ['*']
				}
			}
		}, config || {}));
	},
	allSitesByDate: (config) => {
		return new Query($.extend(true, {}, {
			label: 'All Sites By Date',
			request: {
				indexName: 'wpms_multisite_posts_by_date',
				params: {
					hitsPerPage: 10,
					facets: ['*'],
					// facetFilters: [
					// 	'is_event:true',
					// 	['post_type:post','post_type:webinar']
					// ]
				}
			}
		}, config || {}));
	},
	suggestions: (config) => {
		return new Query($.extend(true, {}, {
			label: 'All Sites',
			request: {
				indexName: 'wpms_multisite_posts_query_suggestions',
				params: {
					hitsPerPage: 10
				}
			}
		}, config || {}));
	}
};

class SearchWrapper {

	constructor(client) {
		this.client = client;
		this.queries = [];
	}

	query(req) {
		return this.batch(req);
	}

	queue() {
		if (!this.current) {
			this.current = new Promise((resolve, reject) => {
				setTimeout(() => {
					const queries = this.queries;
					this.client.search(queries, (err, response) => {
						if (err || !response.results) {
							reject(err);
						}
						else {
							resolve(response.results);
						}
					});
					this.current = false;
					this.queries = [];
				}, 1);
			});
		}
		return this.current;
	}

	batch(req) {
		return new Promise((resolve, reject) => {
			const i = this.queries.length;
			this.queries.push(JSON.parse(JSON.stringify(req)));
			this.queue(req).then(results => {
				resolve(results[i]);
			});
		});
	}

}
export {
	queries, SearchWrapper
};